<template>
    <div class="animated fadeIn apinvfrm">        
        <b-card>
            <div slot="header">
                AP Invoice Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>AP. Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" :disabled="!(saveEnabled) || (kunciNomor===1)"></b-form-input>
                            <b-input-group-append>
                                <b-button  @click="kunciNomor = (kunciNomor===1 ? 0 : 1)" :variant="kunciNomor===1 ? 'secondary' : 'warning'">
                                    <i v-if="kunciNomor===1" class="fa fa-lock" aria-hidden="true"></i>
                                    <i v-else class="fa fa-unlock" aria-hidden="true"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label class="text-right">Trx. Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :disabled="!(saveEnabled)"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >  
                    <b-form-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.postgrpname" :state="!$v.model.postgroup.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuApGroupShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">                            
                            <b-input-group >
                                <b-input-group-prepend><label class="text-right">Supplier/Vendor</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                    <b-btn text="Button" @click="lkuVendorShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      
                    <!-- <b-form-row>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-form-radio-group  v-model="model.partialInvoice" class="ml-1 pt-1">
                                    <b-form-radio value="0">Full P.O Delivery</b-form-radio>
                                    <b-form-radio value="1">Partial P.O Delivery</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label class="text-right">Receiving No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.RecivNo" :state="!$v.model.RecivNo.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuReceivingShow=true" :disabled="(model.partialInvoice==0)">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                       -->
                    <b-form-row v-if="(model.useAPUnbill==1)">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Contract No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.po" :state="!$v.model.kontrak.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuApunbillShow=true"  >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.invoice" :state="!$v.model.invoice.$error"></b-form-input>
                            </b-input-group>

                        </b-col>
                    </b-form-row>                                                             
                    <b-form-row v-else>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>P.O/S.O No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.po" :state="!$v.model.po.$error"></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuPorderShow=true" :disabled="(model.partialInvoice==1)" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.invoice" :state="!$v.model.invoice.$error"></b-form-input>
                            </b-input-group>

                        </b-col>
                    </b-form-row>                                                             
                    <b-form-row>
                        <b-col lg="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.invdate" type="date"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            
                            <b-input-group >
                                 <b-input-group-prepend style="width: 50px;"><label>T.O.P</label></b-input-group-prepend>
                                <b-form-input v-model="model.top" type="number" style="max-width: 70px !important;" min="0"></b-form-input>
                                <b-input-group-append>
                                     <b-input-group-text>
                                        Hari
                                    </b-input-group-text>
                                </b-input-group-append>
                                <b-input-group-prepend class="ml-2"><label>Invoice Due Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.duedate" type="date"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-form-row>     
                    <b-form-row>
                        <b-col cols="6" >
                            <b-input-group >
                                <b-input-group-prepend><label >Invoice Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select class="input-group-text" v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" :state="!$v.model.totalinv.$error" :disabled="!(saveEnabled)"></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice DP/Termin</label></b-input-group-prepend>
                                <b-form-select v-model="model.tagihandp" :plain="true" :options="YesNo" :state="!$v.model.tagihandp.$error"></b-form-select>
                                <b-input-group-append v-if="(model.tagihandp==1)"> <span class="input-group-text">Termin #</span></b-input-group-append>
                                <b-form-select v-if="(model.tagihandp==1)" v-model="model.termin" :plain="true" :options="invoiceTerms" :state="!$v.model.termin.$error" :disabled="(model.tagihandp == 0)"></b-form-select>
                                <b-input-group-append v-if="(model.tagihandp==0)" class="ml-1">
                                    <b-btn text="Button" @click="showApDownpay" variant="warning">
                                        Settlement to DP/Termin Invoices 
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row v-if="(model.matauang !== uanguser)">
                        <b-col cols="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Exchange Rate {{model.matauang}}</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.ratekurs" ></my-number>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      

                    <b-input-group>
                        <b-input-group-prepend><label style="width:150px;">Internal Budget</label></b-input-group-prepend>
                        <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                        <b-input-group-append >
                        <b-btn text="Button" @click="lkuBudgetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
                <b-col lg="4">

                        <b-input-group >
                            <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" :state="!$v.model.kodecash.$error"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('model')" id="apKodecash">
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>

                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblApLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="apLines.items"
                    :fields="apLines.fields"
                    :current-page="apLines.page"
                    :per-page="apLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat('0,0.00')}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editApLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" v-if="saveEnabled" @click="delApLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-tabs card v-model="tabIndex">
                        <b-tab title="INVOICE ITEM DETAIL" active>
                            <b-row h-align="center">
                                <b-col lg="6" xl="6" class="pl-0">
                                    <b-input-group v-if="(model.ibudghdkey)">
                                        <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.budgetline" :state="!$v.apLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                                        <b-input-group-append >
                                        <b-btn text="Button" @click="lkuBudgetInternShow=true" >
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                        <b-form-checkbox v-model="apLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO"  class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.uraian_dt" :state="!$v.apLinesObj.uraian_dt.$error"></b-form-input>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>GL Account#</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.kodeacc" :state="!$v.apLinesObj.kodeacc.$error" :disabled="(apLinesObj.apunbill==1)"></b-form-input>
                                        <b-form-input readonly v-model="apLinesObj.namaacc" :state="!$v.apLinesObj.kodeacc.$error" style="width:50% !important;"></b-form-input>
                                        <b-input-group-append v-if="(!(apLinesObj.apunbill))">
                                        <b-btn text="Button" @click="showLkuCoa('detail')">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.quantity" @change="calcPrice()" type="number" :precision="2" v-b-tooltip.hover :title="apLinesObj.quantity" :disabled="(apLinesObj.apunbill==1)"></b-form-input>
                                                <b-form-input v-model="apLinesObj.unitsize" v-b-tooltip.hover :title="apLinesObj.unitsize" class="ml-1" placeholder="Unit Size"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Unit Price</span></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number :minus="true" class="form-control text-right" v-model="apLinesObj.unitprice" :precision="2" :state="!$v.apLinesObj.unitprice.$error" :disabled="(apLinesObj.apunbill==1)"></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="6" class="pl-0">
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number :minus="true" class="form-control text-right" v-model="apLinesObj.nilai" :precision="2" :state="!$v.apLinesObj.nilai.$error" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="2">                            
                                            <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="apLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" >PPN(VAT)</b-form-checkbox>
                                        </b-col>
                                    </b-form-row >                      

                                    <b-form-row v-if="(apLinesObj.kenappn==1)">
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.dppnlain" @change="calcTaxes()"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.ppn" @change="calcTaxes()"  type="number" v-b-tooltip.hover :title="apLinesObj.ppn"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >         
                                    <b-form-row>
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                <b-form-select v-model="apLinesObj.pasalpph" :plain="true" :options="lookupPPH" :state="!$v.apLinesObj.pasalpph.$error"></b-form-select>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col xl="4">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPH</span></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.pph" @change="calcTaxes()"  type="number" v-b-tooltip.hover :title="apLinesObj.pph"></b-form-input>
                                                <!-- <my-number v-model="apLinesObj.pph" :precision="2"></my-number> -->
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >                          
                                    <b-row no-gutters>
                                        <b-col xl="10">
                                            <b-input-group>
                                                <b-form-select style="font-size:0.78rem !important; margin-left:21px;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" ></b-form-select>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number style="width:40% !important;"  class="form-control text-right" v-model="apLinesObj.nilaipph" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row>

                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="INVOICE ITEM DIMENSION">
                            <b-row align-h="between">
                                <b-col lg="6" v-if="prepaidexp">
                                    <h5  class="ml-2">Setting Amortization - Prepaid Expenses</h5>
                                    <b-input-group >
                                        <b-input-group-prepend><label >Duration/Period</label></b-input-group-prepend>
                                        <b-form-input  v-model="apLinesObj.amortzbln" type="number" ></b-form-input>
                                        <b-input-group-append>
                                        <span class="input-group-text">month(s)</span>
                                        </b-input-group-append>
                                    <!-- </b-input-group>
                                    <b-input-group > -->
                                        <b-input-group-prepend><span class="ml-1 pt-2">Starting &nbsp;</span></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.amortzdate" type="date" style="width:30% !important;"></b-form-input>                                        
                                    </b-input-group>

                                    <b-input-group >
                                        <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="apLinesObj.amortzaccount" ></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="showLkuCoa('debit')" >
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>

                                </b-col>
                                <b-col lg="6">
                                    <v-dim :model="apLinesObj" :key="updateDimDtl"></v-dim>
                                </b-col>
                            </b-row>
                        </b-tab>
                      </b-tabs>
                        <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" v-if="saveEnabled" @click="saveApLines()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <b-button size="sm" class="ml-3" @click="addApLines" v-if="saveEnabled" >Add AP Detail</b-button>                          
                            <div class="ml-3">
                                Showing {{((apLines.page - 1) * apLines.limit + 1)}}
                                to <span v-if="((apLines.page * apLines.limit)>apLines.total)">{{apLines.total}}</span>
                                    <span v-else>{{apLines.page * apLines.limit}}</span>
                                <strong> of {{apLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="apLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="apLines.total"
                            :per-page="apLines.limit"
                            v-model="apLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card>    

            <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                            <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
                        </b-input-group>
                        <b-form-row>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur" ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>Tgl. Faktur</label></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>Tgl. Faktur &nbsp;</span></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date" ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="4">
                                <b-input-group >
                                    <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak {{model.matauang}}</label></b-input-group-prepend>
                                    <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.kursppn" ></my-number>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-col>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>&nbsp;</label></b-input-group-prepend>
                                    <b-form-checkbox id="chkGrossUp" class="ml-2 mt-2" v-model="model.grossup" value=1 unchecked-value=0 @change="calcAmountDue">
                                        Gross Up W/H Tax(PPh)
                                    </b-form-checkbox>
                                    <!-- <b-form-checkbox  v-model="model.taxliable" value=1 unchecked-value=0  class="mt-2 ml-2">PPN dikreditkan</b-form-checkbox> -->
                                </b-input-group>
                            </b-col>
                        </b-form-row>     
                        
                        <b-row class="justify-content-center mb-2">
                            <div style="width:450px;">
                                <b-input-group >
                                    <b-input-group-prepend ><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                                    <b-form-checkbox  v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                        <button  v-else class="btn btn-primary mr-1" @click="saveinfo()"><i class="fa fa-save"></i> Save Invoice's Info </button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>

                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px; font-size:small;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" @change="calcAmountDue"></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="(calcVAT===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                          <b-input-group>
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">AP Account GL</label></b-input-group-prepend>
                                <b-form-input v-model="model.apkodeacc" :state="!$v.model.apkodeacc.$error"></b-form-input>
                                <b-input-group-append >
                                <b-btn text="Button" @click="showLkuCoa('header')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <!-- <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">&nbsp;</label></b-input-group-prepend>
                                <b-form-checkbox  class="ml-3 mt-2" v-model="model.chargeable" value=1 unchecked-value=0>
                                Chargeable to Customer
                                </b-form-checkbox>
                            </b-input-group> -->
                        </div>
                    </b-col>
               </b-row>
            <!-- <b-row align-h="center" no-gutters>
                <b-col md="7" lg="5"  xl="4">
                    <b-input-group >
                        <b-input-group-prepend><label class="text-right">AP Posting Group</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.postgrpname" :state="!$v.model.postgroup.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuApGroupShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col md="5" lg="4" xl="4">
                    <b-input-group >
                        <b-input-group-prepend class="d-sm-inline d-md-none"><label>&nbsp;</label></b-input-group-prepend>
                        <b-form-checkbox  class="ml-3 mt-2" v-model="model.chargeable" value=1 unchecked-value=0>
                        Chargeable to Customer
                        </b-form-checkbox>
                    </b-input-group>
                </b-col>
            </b-row>                -->
        </b-card>
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>        
        <b-modal v-model="lkuApGroupShow" size="lg" :hide-footer="true" title="List of AP Posting Group" :centered="true">
            <lku-appostinggrp @click="onSelectLkuApGroup"></lku-appostinggrp>
        </b-modal>        
        <b-modal v-model="lkuApunbillShow" size="lg" :hide-footer="true" title="List of AP Contract" :centered="true">
            <lku-apunbill @click="onSelectLkuApUnbill" :vendor_id="model.vendor_id" :vendor="model.vendorinfo" :key="model.vendor_id"></lku-apunbill>
        </b-modal>        
        <b-modal v-model="lkuPorderShow" size="lg" :hide-footer="true" title="List of Purchase/Service Order" :centered="true">
            <lku-porder @click="onSelectLkuPorder" :vendor_id="model.vendor_id" :vendor="model.vendorinfo" :key="model.vendor_id"></lku-porder>
        </b-modal>        
        <b-modal v-model="lkuReceivingShow" size="lg" :hide-footer="true" title="Receiving - PO Delivery" :centered="true">
            <lku-receiving @click="onSelectLkuReceiving" :vendor_id="model.vendor_id" :vendor="model.vendorinfo" :key="model.vendor_id"></lku-receiving>
        </b-modal>        

        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
                <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="OUT"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>     
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        
        <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
            <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey" ></lku-budgetinternalline>
        </b-modal>        

        <b-modal v-model="dpConfirm" size="lg" title="List of Invoice DP/Termin" 
            :centered="true"  header-bg-variant="primary" :hide-footer="true" :no-close-on-esc="true" :no-close-on-backdrop="true" :hide-header-close="true">
            <div class="report-wraper">
                    <table style="width: 100%;" class="">
                        <thead>
                            <tr>
                            <th width="30px"></th>
                            <th style="text-align:center" width="100px">Settled Amount</th>
                            <th style="text-align:center" width="100px">AP Number</th>
                            <th style="text-align:center" width="100px">Invoice No.</th>
                            <th style="text-align:center" width="100px">PO Number</th>
                            <th>Description</th>
                            <th style="text-align:center" width="30px">Rp,$,¥</th>
                            <th style="text-align:center" width="120px">Invoice Total (Excl.VAT)</th>
                            <th style="text-align:center" width="100px">UnSettled Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in apDownpay" :key="row.notgl" >
                                <td width="30px">    
                                    <b-form-checkbox v-model="row.selected" :value="1" :unchecked-value="0"/>
                                </td>
                                <td style="margin:0;padding:0;"><div style="width: 120px; overflow: hidden; display: inline-block; white-space: nowrap;" >
                                    <my-number v-model="row.nilai" class="form-control text-right"  style="border:none;font-size: 0.8rem !important;" :precision="2" ></my-number></div>
                                </td>
                                <td class="disabled">{{row.nomor}}</td>
                                <td class="disabled">{{row.invoice}}</td>
                                <td class="disabled">{{row.po}}</td>
                                <td class="disabled">{{row.uraian}}</td>
                                <td class="disabled" width="30px">{{row.matauang}}</td>
                                <td class="disabled" style="text-align:right">{{row.totalinvxppn | numFormat('0,0.00')}}</td>
                                <td class="disabled" style="text-align:right">{{row.SisaDP | numFormat('0,0.00')}}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>                  
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="success" class="ml-1" @click="onSelectApDownpay" > <i class="fa fa-check-circle-o"></i> Confirm</b-button>
                  <b-button variant="danger" class="ml-1" @click="onCancelApDownpay" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">
    .apinvfrm {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 130px;
                }
            }
        }
        .form-group {
            margin-bottom:2px;
            .input-group {
                padding-bottom:0;
            }
        }
        .row-details-form {
            label {
            text-align: right !important;
            }
            legend {
            text-align: right !important;;
            }
        }

    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuAppostinggrp from "../lookup/lkuApGroup";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "../lookup/lkuBudgetinternallineLazzy";
import lkuApunbill from "../lookup/lkuApkontrak";
import lkuVendor from "../lookup/lkuVendor";
import lkuPorder from "../lookup/lkuPorder";
import lkuReceiving from "../lookup/lkuReceiving";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import apinv from "../../apis/apinv";
import procure from "../../apis/procure";
import procreceiv from "../../apis/procreceiv";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading,myNumber, vDim, lkuApunbill, lkuAppostinggrp, lkuBudgetinternal, lkuBudgetinternalline, lkuVendor, lkuPorder,lkuReceiving,lkuCashflow,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            vendor: { required },
            apkodeacc: { required },
            po: { required:requiredIf('use_procure') },
            uraian: { required },
            tanggal: { required },
            postgroup: { required },
            kodecash: { required:false },
            matauang: { required },
            tagihandp: { required },
            invoice: { required },
            termin: { required:requiredIf('tagihandp') },
            // nofaktur: {required : (function() {
            //     if ((this.model.nilaippn || 0) == 0) {
            //         return true;
            //     } else if ((this.model.nofaktur || '')==''){
            //         return false;
            //     } else return true;
            // })},
            // tglfaktur: {required : (function() {
            //     if ((this.model.nilaippn || 0) == 0) {
            //         return true;
            //     } else if (!(this.model.tglfaktur)){
            //         return false;
            //     } else return true;
            // })},
            RecivNo: {required : (function() {
                if ((this.model.partialInvoice || 0) == 0) {
                    return true;
                } else if (!(this.model.RecivNo)){
                    return false;
                } else return true;
            })},
            kontrak: {required : (function() {
                if ((this.model.useAPUnbill || 0) == 0) {
                    return true;
                } else if (!(this.model.kontrak)){
                    return false;
                } else return true;
            })},
            totalinv: { required, minValue:minValue(1) },
            ratekurs: { required, minValue:minValue(0.00000001) }
        },
        apLinesObj: {
            kodeacc: { required },
            uraian_dt: { required },
            quantity: { required, minValue:minValue(0.00000001) },
            unitprice: {required : (function() {
                if (parseFloat(this.apLinesObj.unitprice || 0) == 0) {
                    return false;
                } else return true;
            })},
            nilai: { required },
            // ppn: { numeric },
            // kenappn: { required },
            pasalpph: {required : (function() {
                if ((this.apLinesObj.nilaipph || 0) == 0) {
                    return true;
                } else if (((this.apLinesObj.pasalpph || '')=='') || (this.apLinesObj.pasalpph== 'N/A') || (this.apLinesObj.pasalpph== 'NO WHT')){
                    return false;
                } else return true;
            })},
            ibudgdtkey: { required:(function() {
                if (this.model.ibudghdkey) {
                    if (this.apLinesObj.ibudgdtkey) {
                        if (this.apLinesObj.ibudghdkey=='N/A')
                            return true;
                        else {
                            if (this.model.ibudghdkey==this.apLinesObj.ibudghdkey) {
                                return true;
                            } else {
                                toastr.error(`Budget Line not from Internal Budget`,'Line/Detail AP',10000);                                
                                return false;
                            }
                        }
                    } else return false;
                } else return true;
            }) },

        },
  }, 
  data() {
    return {
        watching_pasalpph:false,
        kunciNomor: 1,            
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        saveEnabled:true,
        isLoading:false,
        lkuBudgetShow: false,
        lkuBudgetInternShow: false,
        lkuBudgetInternData:{},
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'model',        
        lkuApGroupShow: false,
        lkuVendorShow: false,
        lkuPorderShow: false,
        lkuReceivingShow: false,
        lkuApunbillShow:false,
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 10,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        coa:[],
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        currency:[{value:'IDR',text:'IDR'}],
        invoiceTerms: [{ value: '', text: '-' }, { value: 'Term#1', text: 'Term#1' }, { value: 'Term#2', text: 'Term#2' },
                { value: 'Term#3', text: 'Term#3' }, { value: 'Term#4', text: 'Term#4' }
        ],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model: {
            invoice:'', 
            useAPUnbill:0, kontrak:'',
            vendor: '',apkodeacc:'',
            po: '',partialInvoice:0,
            uraian: '',
            tanggal: moment().format('YYYY-MM-DD'),
            postgroup: '',
            kodecash: '',
            matauang: 'IDR',
            tagihandp: 0,
            termin: '',
            nofaktur: '',
            tglfaktur: '',
            totalinv: 0, nilaippn:0,grossup:0, totalpph:0,
            ratekurs: 1, kursppn:1, DimTableKey:'',
            top:0,//term of payment,
            duedate:'',invdate:'', ibudghdkey:''
        },
        apLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian_dt",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "Amount VAT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        apLinesObj: {
            kodeacc: '',namaacc:'', glAccount:'',
            uraian_dt: '',
            quantity: 0,
            unitprice: 0,
            nilai: 0, nilaipph:0,
            ppn: 0,
            kenappn: 0,
            pasalpph: 'NO WHT',
            pph: 0, unitzise:'', DimTableKey:'', amortzbln:0, amortzdate:'',
            amortzkodeacc:'',amortznamaacc:'',amortzaccount:'',
            ibudgdtkey:'',ibudgdtkeyflag:'YES',
            budgetbalance: 0
        },
        tabIndex:0,
        lkuCoaShow:false,
        lkuCoaColler:'',
        saveClick:false,
        apDpSttl: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nilai",
                    label: "Settled Amount",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
                {
                    key: "nomor",
                    label: "AP Number",
                    thStyle: "width:140px",
                },
                {
                    key: "invoice",
                    label: "Invoice No.",
                    thStyle: "width:140px",
                },
                {
                    key: "po",
                    label: "PO Number",
                    thStyle: "width:140px",
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥",
                    sortable: true
                },
                {
                    key: "totalinvxppn",
                    label: "Total Invoice\ (Excl. VAT)",
                    thStyle: "width:140px",
                    thClass: "text-center",
                    tdClass: "text-right"
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        dpConfirm: false,
        apDownpay:[],
        prepaidexps:[],
        prepaidexp:false
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidApLines() {
      this.$v.apLinesObj.$touch();
      return this.$v.apLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    use_procure(){
        return (this.$store.state.user.use_procure == 1);
    },
    // tagihandp(){
    //     return (this.model.tagihandp == 1);
    // },
    noPPN(){
        return (this.model.nilaippn == 0);
    },
    unitprice(){
        return this.apLinesObj.unitprice;
    },
    // pasalpph(){
    //     return this.apLinesObj.pasalpph;
    // },
    // prepaidexp(){
    //     const ketemu = this.prepaidexps.find(ac => ac.kodeacc==this.apLinesObj.kodeacc);
    //     return (ketemu);
    // }    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
    // tagihandp: function(newval) {
    //     // console.log('Invoice Termin ? :',newval);
    //     if (!newval) this.model.termin='';
    // },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },
    // 'model.top': function(newval) {
    //     this.model.duedate = (this.model.duedate) ? moment(moment(this.model.invdate).add(newval, 'days')).format('YYYY-MM-DD') : this.model.invdate;
    // },
    // 'model.duedate': function(duedate) {
    //     this.model.top = (this.model.duedate) ? moment(duedate).diff(moment(this.model.invdate),'days') : 0;
    // },
    // 'model.invdate':function(invdate){
    //     // this.model.top = (this.model.duedate) ? moment(this.model.duedate).diff(moment(invdate),'days') : 0;
    //     this.model.duedate = (this.model.duedate) ? moment(moment(this.model.invdate).add(this.model.top, 'days')).format('YYYY-MM-DD') : this.model.invdate;
    // },
    'apLinesObj.nilai': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    
    'apLinesObj.pph': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },    
    'apLinesObj.ppn': function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },   
    'apLinesObj.grossup' : function(newval) {
        setTimeout(() => {
            this.calcTaxes();
        }, 100);
    },   
    'apLinesObj.ibudgdtkeyflag' : function(newval) {
        setTimeout(() => {
            if (this.apLinesObj.ibudgdtkeyflag=='YES'){
                this.apLinesObj.ibudghdkey='N/A';
                this.apLinesObj.ibudgdtkey='N/A';
                this.apLinesObj.budgetline='';
            } else {
                this.apLinesObj.ibudghdkey=(this.apLinesObj.ibudghdkey=='N/A') ? '':this.apLinesObj.ibudghdkey;
                this.apLinesObj.ibudgdtkey=(this.apLinesObj.ibudgdtkey=='N/A') ? '':this.apLinesObj.ibudgdtkey;
                this.apLinesObj.budgetline=(this.apLinesObj.ibudgdtkey=='N/A') ? '':this.apLinesObj.budgetline;
            }
            this.$forceUpdate();
        }, 100);
    },   

  },
  created: async function(){
      if (this.$route.params.apinvkey)  {
          toastr.info('Loading AP Detail, please wait')
          try {
            const [a,b,c,f,data] = await Promise.all([apinv.postgroup(), apinv.pasalpph(),apinv.currency(),apinv.prepaidexp(),apinv.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.prepaidexps=f;
            // const data = await apinv.detail(this.$route.params);  
            const row = data[0][0];
            console.log (row.duedate);
            this.saveEnabled=(row.posting === 0);
            row.top = (row.duedate) ? moment(row.duedate).diff(moment(row.invdate),'days'): 0;
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : '';   

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.partialInvoice = (this.model.RecivNo) ? 1:0;
            this.calcVAT=row.calcVAT||1;

            this.apLines.items = data[1];
            this.apLines.items.forEach(line => {
                line.nilaiB4=line.nilai;
            });
            this.apLines.total=this.apLines.items.length;
            this.apDpSttl.items = data[2];
            this.apDpSttl.total=this.apDpSttl.items.length;
            this.tahun=0;
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            setTimeout(() => {
                this.calcTotalDtlAp();
            }, 1000); 
            // this.$forceUpdate();
            this.inputBerlanjut=0;
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        const [a,b,c,f, e] = await Promise.all([apinv.postgroup(), apinv.pasalpph(),apinv.currency(),apinv.prepaidexp(), apinv.getcoa({ tahun: this.tahun})]) ;
        this.postGroups = a;
        this.lookupPPH = b;
        this.currency = c;
        this.prepaidexps=f;
        this.coa = e;
      }
    this.$watch('model.tagihandp', function(newval) {
        if (newval==0){
            this.model.termin='';
        }
    });            
    this.$watch('model.partialInvoice', function(newval) {
        if (newval==0){
            this.model.RecivNo='';
            this.model.RecivKey='';
        }
    });
    this.$watch('model.invdate', function(newval) {
        setTimeout(() => {
            this.model.duedate = (this.model.duedate) ? moment(moment(newval).add(this.model.top, 'days')).format('YYYY-MM-DD') : newval;                
        }, 100);
    });            
    this.$watch('model.top', function(newval) {
        this.model.duedate = (this.model.duedate) ? moment(moment(this.model.invdate).add(newval, 'days')).format('YYYY-MM-DD') : this.model.invdate;
    });

    this.$watch('apLinesObj.pasalpph', function(newval) {
        if (this.watching_pasalpph==true) {
            const item = this.lookupPPH.find(p => p.value==newval);
            if (item) {
                this.apLinesObj.pph=item.pph;
                setTimeout(() => {
                    this.calcTaxes();
                }, 100);
            }
        }
    });            
    // this.watching_pasalpph=true;            
    this.$watch('apLinesObj.kodeacc', function(newval) {
      setTimeout(() => {
          if ((this.apLinesObj.kodeacc === newval) && (newval)) {
        //   if (newval) {
            console.log(' coa diketik : ', newval);
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
            console.log(' coa ketemu : ', _selected);
                this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
                this.apLinesObj.kodeacc = _selected.kodeacc;
                this.apLinesObj.namaacc = _selected.namaacc;
                this.$forceUpdate();  
                this.dimension.forEach((dim) => {
                    if (_selected[dim.value]) {
                        this.apLinesObj[dim.value] = _selected[dim.value];
                        this.apLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                        // this.apLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                        this.apLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                    }
                });      
            } else {
                console.log(' coa tidak ketemu : ', this.apLinesObj.kodeacc);
                this.apLinesObj.kodeacc='';
                this.apLinesObj.namaacc = '';
            }
          }
      }, 500);
    });            

    this.$watch('model.apkodeacc', function(newval) {
      setTimeout(() => {
          if ((this.model.apkodeacc === newval) && (newval)) {
            console.log(' coa diketik : ', newval);
            const _selected = this.coa.find(p => p.kodeacc==newval);
            if (_selected) {
            console.log(' coa ketemu : ', _selected);
                this.model.apkodeacc = _selected.kodeacc;
                this.model.namaacc = _selected.namaacc;
                this.model.postgroup = (_selected.kodeacc || '').substring(0,6);
                const apgroup= this.postGroups.find(d => d.value==this.model.postgroup);    
                if (apgroup) {
                    this.model.postgrpname = apgroup.text;
                } else {
                    this.model.postgroup=''
                }            

                this.$forceUpdate();  
            } else {
                console.log(' coa tidak ketemu : ', this.model.apkodeacc);
                this.model.apkodeacc='';
                this.model.namaacc = '';
            }
          }
      }, 500);
    });            
    this.$watch('model.ibudghdkey', function(newval) {
        // setTimeout(() => {
            this.apLinesObj.ibudgdtkeyflag='YES'
            this.apLinesObj.ibudghdkey='N/A';
            this.apLinesObj.ibudgdtkey='N/A';
            this.apLinesObj.budgetline='';
            if (this.apLines && Array.isArray(this.apLines.items)) {
                this.apLines.items.forEach((line)=>{
                    line.ibudgdtkey='';
                    line.budgetline='';
                    line.ibudgdtkeyflag='YES';
                });         
            }
        // }, 200);
    });

  },
  methods: {
    onSelectLkuBudget: async function (_selected) {
        try {
            this.model.uraian = (this.model.uraian) ? this.model.uraian: _selected.uraian;
            this.model.budgetname = _selected.uraian;
            this.model.budgetnumber = _selected.nomorintern;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.uraian;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;
            this.model.DimTableKey = _selected.DimTableKey;

            this.dimension.forEach((dim) => {
                if (_selected[dim.value]) {
                    this.model[`${dim.value}`] = _selected[dim.value];
                    this.model[`${dim.value}Txt`] = _selected[dim.value].trim();
                    this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                }
                if (dim.RelatedObj=='internalbudget') {
                    this.model[`${dim.value}`] = _selected.nomorintern;
                    this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
                    this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
                }
            });


            this.updateDimHdr=!this.updateDimHdr;

            this.lkuBudgetShow=false;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
        try {
            this.apLinesObj.jccostname = ibLineObj.selected.jccostname;
            this.apLinesObj.budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote}`;
            this.apLinesObj.ibudgdtkey = ibLineObj.selected.ibudgdtkey;
            this.apLinesObj.ibudghdkey = ibLineObj.selected.ibudghdkey;
            this.apLinesObj.ibudgdtkeyflag= 'NO';
            if (!(this.apLinesObj.uraian))  this.apLinesObj.uraian=this.apLinesObj.budgetline;

            const res = await procure.budgetprogressdtlsmry({ ibudgdtkey: ibLineObj.selected.ibudgdtkey });
            if (res) {
                this.apLinesObj.budgetbalance = res.ibbudgetamt - (res.usagettl || 0);
            } else {
                this.apLinesObj.budgetbalance = 0;
            }

            this.dimension.forEach((dim) => {
                if (ibLineObj.selected[dim.value]) {
                    this.apLinesObj[`${dim.value}`] = ibLineObj.selected[dim.value];
                    this.apLinesObj[`${dim.value}Txt`] = ibLineObj.selected[dim.value].trim();
                    this.apLinesObj[`${dim.value}Info`] = ibLineObj.selected[dim.value] + ' | '+ ibLineObj.selected[`${dim.value}Txt`];
                }
            });

            this.lkuBudgetInternShow=false;
            this.lkuBudgetInternData=ibLineObj;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    async showApDownpay() {
        try {
            this.$v.model.$touch();            
            if (this.$v.model.vendor.$error) {
                // console.log('validation : ', this.$v.model);
                // console.log('model obj : ',this.model);
                toastr.error('Please fill the Vendor/Supplier & PO.Number', "ERROR MESSAGE");
                return
            }
            const data = await apinv.getUangmuka({ vendor_id: this.model.vendor_id, po: this.model.po }) ;
            this.apDownpay = data;
            let ApDpIdx;
            if (this.apDownpay.length==0) {
                console.log('(apDownpay.length==0)');
                this.apDpSttl.items.forEach((d,idx)=>{
                    const dp1={};
                    for (var key in d) {
                        dp1[key] = d[key];
                    }
                    dp1.selected=1;
                    dp1.apinvkey=d.notgl;
                    dp1.notgl=d.apinvkey;
                    dp1.nilai=d.nilaisettl;
                    this.apDownpay.push(dp1);    
                });
            } else {
                // console.log('apDpSttl.length=',this.apDpSttl.items.length);
                this.apDownpay.forEach((dp,idx)=>{
                    dp.selected=0;
                    // if (dp.po===this.model.po){
                    //     dp.selected=1;
                    // } else {
                        ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
                        if (ApDpIdx>-1){
                            dp.idrowunik=this.apDpSttl.items[ApDpIdx].idrowunik;
                            dp.selected=1;
                            dp.nilai=this.apDpSttl.items[ApDpIdx].nilaisettl;
                        }
                    // }
                });
                this.apDpSttl.items.forEach((d,idx)=>{
                    ApDpIdx = this.apDownpay.findIndex(dp => dp.apinvkey==d.notgl)
                    if (ApDpIdx==-1){
                        const dp1={};
                        for (var key in d) {
                            dp1[key] = d[key];
                        }
                        dp1.selected=1;
                        dp1.apinvkey=d.notgl;
                        dp1.notgl=d.apinvkey;
                        dp1.nilai=d.nilaisettl;
                        this.apDownpay.push(dp1);    
                    }
                });

            }
            // console.log('this.apDownpay : ',this.apDownpay);
            this.dpConfirm=true;
        } catch (error) {
            console.log(error);
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    onCancelApDownpay() {
        this.dpConfirm=false;
        this.saveClick=false;
    },
    async onSelectApDownpay() {
        // cek apakah sisa DP mencukupi
        let DPcukup=true;
        DPcukup = await apinv.cekUangmukaCukup({apinvkey: this.model.apinvkey || '', dpTerpilih : this.apDownpay.filter(dp => ((dp.selected==1) && (dp.nilai != 0)))});
        if (DPcukup==true){
            // if (this.saveClick===true) {
                const totaldp= this.apDownpay.reduce((a, b) => {
                                if (b.selected==1) a += b.nilai;
                                return a; 
                            }, 0);
                this.calcTotalDtlAp();
                this.calcAmountDue();
                if (((this.model.totalap || 0) - totaldp)<-1) {
                    toastr.error('Nilai Uang Muka yang di alokasikan melebihi total invoice','ERROR MESSAGE',10000);
                    return;
                } 
            // }
            this.dpConfirm=false;
            if (this.saveClick===true) {
                // pindahkan ke apDpSttl 
                // yg terselect dan nilainya tidak Nol aja
                let ApDpIdx;
                const dpTerpilih = this.apDownpay.filter(dp => ((dp.selected==1) && (dp.nilai != 0)));
                dpTerpilih.forEach((dp,idx)=>{
                    dp.notgl=dp.apinvkey;
                    dp.apinvkey=this.model.apinvkey || '';
                    dp.idrowunik='';
                    ApDpIdx = this.apDpSttl.items.findIndex(d => d.notgl==dp.apinvkey)
                    if (ApDpIdx>-1){
                        dp.idrowunik=this.apDpSttl.items[ApDpIdx].idrowunik;
                    }
                });
                this.apDpSttl.items=dpTerpilih;
                this.save();
            }
        } else {
            toastr.error('Nilai Uang Muka/DP tidak mencukupi (total settlement melebihi total DP)','ERROR MESSAGE',10000);
        }
    },
    onSelectLkuApGroup(_selected) {
        this.model.postgroup = _selected.postgrpcode.trim();
        this.model.postgrpname = _selected.postgrpname;
        this.model.useAPUnbill = _selected.useAPUnbill;
        this.lkuApGroupShow=false;
    },    
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
        this.lkuCashflowShow=false;
    },
    calcPrice : function() {
        this.apLinesObj.nilai = parseFloat(this.apLinesObj.quantity) * parseFloat((this.apLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.apLinesObj.dppnlain=this.apLinesObj.dppnlain || 100; 
        this.apLinesObj.nilainett = this.apLinesObj.nilai;
        this.apLinesObj.dpp = parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlain) / 100;
        this.apLinesObj.ppn = this.apLinesObj.ppn || this.tarifPPN;
        if (this.apLinesObj.kenappn == 1) {
            // this.model.grossup = 0;
            this.apLinesObj.nilaippn = (this.apLinesObj.ppn/100) * this.apLinesObj.dpp;
        } else {
            this.apLinesObj.nilaippn = 0;
        }
        
        
        if (this.model.grossup == 1)
            this.apLinesObj.dpp = this.apLinesObj.dpp * (100 / (100 - this.apLinesObj.pph));

        this.apLinesObj.nilaidue = this.apLinesObj.nilainett + this.apLinesObj.nilaippn;
        if (this.calcPPh == 1) {
            this.apLinesObj.nilaipph = this.apLinesObj.dpp * parseFloat(this.apLinesObj.pph) / 100
        }
        this.$forceUpdate();
    },
    calcAmountDue : function() {
        this.calcPPh = 1;
        this.calcTotalDtlAp();
        this.model.ttlamtdue = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippn || 0);
        this.model.totalap= (this.model.grossup==1) ? this.model.ttlamtdue : this.model.ttlamtdue-this.model.totalpph;
        console.log('Total AP : ',this.model.totalap);
        toastr.info(`Total AP after W/H Tax: ${this.model.totalap.toLocaleString(undefined, { maximumFractionDigits: 2 })} , DPP: ${this.model.nilaidpp.toLocaleString(undefined, { maximumFractionDigits: 2 })} `);

    },    
    onSelectLkuVendor: async function (_selected) {
        this.lkuVendorShow=false;
        this.model.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.model.apkodeacc = _selected.apkodeacc;
        const dim = this.dimension.find(d => d.RelatedObj=='vendor');
        if (dim) {
            this.model[`${dim.value}`] = _selected.vendor_code;
            this.model[`${dim.value}Txt`] = _selected.vendor_name.trim();
            this.model[`${dim.value}Info`] = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        }
        if ((!(this.model.postgroup)) && (_selected.apgroup)) {
            const apgroup= this.postGroups.find(d => d.value==_selected.apgroup);    
            if (apgroup) {
                this.model.postgroup = _selected.apgroup;
                this.model.postgrpname = apgroup.text;
            }            
        }    
    },
    async onSelectLkuApUnbill(_selected) {
        // if (_selected.posting!=1) {
        //     toastr.error('AP CONTRACT/UNBILL belum diposting tidak bisa dipilih, silahkan lakukan posting dulu!');
        //     return;
        // }
        this.lkuApunbillShow=false;
        this.model.po = _selected.nomor;
        this.model.kontrak = _selected.kontrakKey;
        this.model.vendor = _selected.vendor;
        this.model.vendor_id = _selected.vendor_id;
        this.model.vendorinfo = _selected.vendor.trim() + ' | ' + _selected.vendor_name;
        this.model.apkodeacc = _selected.apkodeacc;
        // this.model.postgroup = (_selected.postgrp || '').trim();
        _selected.apgroup = _selected.apgroup || _selected.postgrp;
        if ((!(this.model.postgroup)) && (_selected.apgroup)) {
            const apgroup= this.postGroups.find(d => d.value==_selected.apgroup);    
            if (apgroup) {
                this.model.postgroup = _selected.apgroup;
                this.model.postgrpname = apgroup.text;
            }            
        }    
        this.model.matauang = _selected.matauang;
        this.model.totalinv = _selected.siskontrak;
           if (!(this.model.uraian)) {
               this.model.uraian=_selected.agreement_title;
           }
        this.model.nilaidpp = _selected.siskontrak;
        this.model.nilaippn = 0;
        this.model.ttlnetto = _selected.siskontrak;
        this.model.ttlamtdue = _selected.siskontrak;

        this.apLines.items = [];
        const  newLine = {
            lineno : 1,
            uraian_dt : `Reclass ${_selected.nomor || 'AP CONTRACT/UNBILL'}`,
            kodeacc : _selected.ApUnBillCrAcc,
        };
        if (newLine.kodeacc)
        {
            const _account = await apinv.findcoa({ kodeacc: newLine.kodeacc, tahun: this.tahun });
            if (_account) {
                newLine.glAccount = _account.kodeacc.trim() + ' | ' + _account.namaacc.trim();
            } else {
                newLine.glAccount = newLine.kodeacc.trim() + ' | ---';
            }
        } else {
            newLine.glAccount = '-- Please select ! -- ';
        }

        this.apLines.items.push(newLine);
    },
    async onSelectLkuPorder(_selected) {
        this.lkuPorderShow=false;
        this.model.po = _selected.orderno;
        this.model.pohdrkey = _selected.pohdrkey;
        this.model.vendor = _selected.vendor;
        this.model.apkodeacc = _selected.apkodeacc;
        this.model.vendor_id = _selected.vendor_id;
        this.model.vendorinfo = _selected.vendor.trim() + ' | ' + _selected.vendor_name;
        if ((!(this.model.postgroup)) && (_selected.apgroup)) {
            const apgroup= this.postGroups.find(d => d.value==_selected.apgroup);    
            if (apgroup) {
                this.model.postgroup = _selected.apgroup;
                this.model.postgrpname = apgroup.text;
            }            
        }    

        this.model.postgroup = (_selected.postgrp || '').trim();
        this.model.matauang = _selected.matauang;
        this.model.totalinv = _selected.nilaidue;
        this.model.chargeable = _selected.chargeable;
           if (!(this.model.uraian)) {
               this.model.uraian=_selected.remark;
           }
        this.model.nilaidpp = _selected.dpp;
        this.model.nilaippn = _selected.nilaippn;
        this.model.DimTableKey = _selected.DimTableKey;
        this.model.budgetinfo = _selected.budgetinfo;
        this.model.ibudghdkey = _selected.ibudghdkey;

        if (_selected.ibudgdtkey){
            this.model.budgetline = `${_selected.jccostname} ${_selected.jccostnote}`;
            this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
        }

        try {
            const data = await procure.detailap({ pohdrkey: _selected.pohdrkey }) ;
            // console.log('Po Detail ; ', data);
            const row = data[0][0];
            if (row.ibudghdkey){
                this.model.ibudghdkey = row.ibudghdkey;
                this.model.budgetname = row.budgetname;
                this.model.budgetnumber = row.budgetnumber;
                this.model.nomorproduksi = row.nomorproduksi;
                if (row.budgetinfo){
                    this.model.budgetinfo = row.budgetinfo;
                } else {
                    this.model.budgetinfo = row.noprodintern+' | '+row.budgetname;
                }
            }

            // isi Dimension Header Ap dengan Dimension Header PO ?
            this.model.DimTableKey=row.DimTableKey;
            this.updateDimDtl2Hdr(row);
            this.calcVAT = this.calcVAT || 1;
            if (this.model.tagihandp == 0)
            {
                var lines = data[1];
                console.log('masuk tagihandp==0: lines: ', lines);
                this.apLines.items = [];
                this.model.ttlnetto = 0;
                this.model.ttlamtdue = 0;
                this.model.totalpph = 0;
                let nilaippn= 0;
                let newLine;
                for (let i = 0; i < lines.length; i += 1) {
                    newLine = {};
                    for (let key in lines[i]) {
                        newLine[key] = lines[i][key];
                    }                    
                    this.model.ttlnetto = this.model.ttlnetto + (newLine.nilai || 0);
                    nilaippn += (newLine.nilaippn || 0);
                    this.model.ttlamtdue = this.model.ttlnetto + (this.model.nilaippn || 0);
                    this.model.totalpph = this.model.totalpph + (newLine.nilaipph || 0);

                    newLine.lineno = i + 1;
                    //newLine.uraian_dt = (lines[i].linetype == 1) ? lines[i].description : (lines[i].itemname || '');
                    newLine.uraian_dt = (lines[i].itemname || '') +' \n'+ (lines[i].description || ' ').substring(0,200) ;
                    // newLine.glAccount = (lines[i].kodeacc) ? (lines[i].kodeacc || '').trim() + ' | ' + (lines[i].itemname || '') : '-- Please select ! -- ';
                    if ((lines[i].apunbill || 0)==1){
                        newLine.kodeacc= lines[i].apunbillacc
                    }
                    if (newLine.kodeacc)
                    {
                        const _account = await apinv.findcoa({ kodeacc: newLine.kodeacc, tahun: this.tahun });
                        if (_account) {
                            newLine.glAccount = _account.kodeacc.trim() + ' | ' + _account.namaacc.trim();
                        } else {
                            newLine.glAccount = newLine.kodeacc.trim() + ' | ---';
                        }
                    } else {
                        newLine.glAccount = '-- Please select ! -- ';
                    }

                    this.apLines.items.push(newLine);
                }
                if (this.calcVAT == 1) this.model.nilaippn = 0;
            } else {
                console.log('masuk tagihandp==1')
                var terms = data[2];
                const termin = terms.find( t => t.namaterm == this.model.termin);
                if (termin)
                {
                    this.model.totalinv = termin.nilai;
                    this.model.nilaidpp = termin.nilai;
                    this.model.ttlnetto = termin.nilai;
                    this.model.ttlamtdue = termin.nilai;
                    this.model.totalpph = 0;

                    const newLine = {};
                    newLine.uraian_dt = this.model.termin + ' ' + row.remark ;
                    newLine.kodeacc = row.PrePaymDbAcc;
                    if (row.PrePaymDbAcc)
                    {
                        const _account = await apinv.findcoa({ kodeacc: row.PrePaymDbAcc, tahun: this.tahun });
                        if (_account) {
                            newLine.glAccount = _account.kodeacc.trim() + ' | ' + _account.namaacc.trim();
                        } else {
                            newLine.glAccount = row.PrePaymDbAcc.trim() + ' | ---';
                        }
                    } else {
                        newLine.glAccount = '-- Please select ! -- ';
                    }
                    newLine.quantity=1;
                    newLine.unitsize='LS';
                    newLine.unitprice = termin.nilai;
                    newLine.nilai = termin.nilai;
                    newLine.nilainett = parseFloat(newLine.nilai);
                    if (newLine.kenappn == 1) {
                        newLine.dpp = parseFloat(newLine.nilainett) * parseFloat(newLine.dppnlain) / 100;
                        newLine.ppn = this.tarifPPN;
                    } else {
                        newLine.dpp = 0;
                        newLine.ppn = 0;
                    }
                    newLine.nilaippn = 0.1 * newLine.dpp;
                    newLine.nilaidue = newLine.nilainett + newLine.nilaippn;
                    newLine.nilaipph = newLine.dpp * newLine.pph / 100;
                    this.apLines.items.push(newLine);

                }
            }
        } catch (error) {
            this.isLoading=false;
            this.lkuPorderShow=true;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    async onSelectLkuReceiving(_selected) {
        this.lkuReceivingShow=false;
        this.model.po = _selected.orderno;
        this.model.pohdrkey = _selected.pohdrkey;
        this.model.vendor = _selected.vendor;
        this.model.vendor_id = _selected.vendor_id;
        this.model.vendorinfo = _selected.vendor.trim() + ' | ' + _selected.vendor_name;
        this.model.apkodeacc = _selected.apkodeacc;

        try {
            const data = await procreceiv.detail({ RecivKey: _selected.RecivKey }) ;
            // console.log('Po Detail ; ', data);
            const row = data[0][0];
            this.model.RecivKey = row.RecivKey;
            this.model.RecivNo=row.RecivNo;
            this.model.tanggal=row.RecivDate ? moment(row.RecivDate).format('YYYY-MM-DD') : '';;
            this.model.invoice=row.DoNumber || row.RecivNo;
            this.model.invdate=row.DoDate ? moment(row.DoDate).format('YYYY-MM-DD') : '';
            this.model.uraian= row.remark;
            this.model.po = row.orderno;
            this.model.pohdrkey = row.pohdrkey;
            this.model.nilaidue_po = row.nilaidue_po;
            this.model.nilaiinv_po = row.nilaiinv_po;
            this.model.lastinvoiceno = row.invoiceno;
            
            this.model.vendor_id = row.vendor_id;
            this.model.vendor = row.vendor;
            this.model.vendorinfo = row.vendor_name.trim() + ' | ' + row.vendor_code;
            // this.model.postgroup = (row.postgrp || '').trim();
            // const kelpAp= this.postGroups.find(p=> p.value==this.model.postgroup);
            // if (kelpAp) {
            //     this.model.postgrpname = kelpAp.postgrpname;
            // }
            _selected.apgroup = _selected.apgroup || (row.postgrp || '').trim();
            if ((!(this.model.postgroup)) && (_selected.apgroup)) {
                const apgroup= this.postGroups.find(d => d.value==_selected.apgroup);    
                if (apgroup) {
                    this.model.postgroup = _selected.apgroup;
                    this.model.postgrpname = apgroup.text;
                }            
            }    


            this.model.matauang = row.matauang;
            this.model.ratekurs = 1;
            this.model.chargeable = row.chargeable;
            this.model.DimTableKey = row.DimTableKey;

            setTimeout(() => {
                this.updateDimDtl2Hdr(row);            
            }, 500);

            this.calcVAT = this.calcVAT || 0;
            var lines = data[1];
            this.Lines = data[1];
            this.apLines.items = [];
            this.model.ttlnetto = 0;
            this.model.ttlamtdue = 0;
            this.model.totalpph = 0;
            let nilaippn= 0;
            let newLine;
            for (let i = 0; i < lines.length; i += 1) {
                newLine = {};
                for (let key in lines[i]) {
                    newLine[key] = lines[i][key];
                }
                newLine.ppn= this.tarifPPN;
                newLine.dppnlain= 100;
                newLine.dpp= (lines[i].kenappn==1) ? lines[i].nilainett : 0;
                this.model.ttlnetto = this.model.ttlnetto + (newLine.nilai || 0);
                nilaippn += (newLine.nilaippn || 0);
                this.model.ttlamtdue = this.model.ttlnetto + (this.model.nilaippn || 0);
                this.model.totalpph = this.model.totalpph + (newLine.nilaipph || 0);

                newLine.lineno = i + 1;
                // newLine.uraian_dt = lines[i].itemname.substring(0,250).trim(); lines[i].description.substring(0,250).trim();
                newLine.uraian_dt = (`${(lines[i].itemname || '').trim()} ${(lines[i].description || '').trim()}`).substring(0,250).trim();
                newLine.glAccount = (lines[i].kodeacc) ? (lines[i].kodeacc || '').trim()  : '-- Please select ! -- ';
            
                // let akun=this.inventoryAcc.find(i => i.kodeacc == newLine.kodeacc);
                // if (akun){
                //     newLine.posttype=1
                //     newLine.postname='INVENTORY';
                // } else {
                //     akun=this.fixedassetAcc.find(i => i.kodeacc ==newLine.kodeacc);
                //     if (akun){
                //         newLine.posttype=2
                //         newLine.postname='FIXED ASSET';
                //     } else {
                //         newLine.posttype=3
                //         newLine.postname='EXPENSES';
                //     }
                // }
                
                this.apLines.items.push(newLine);
            }
            if (this.calcVAT == 1) this.model.nilaippn = 0;
            this.calcTotalDtlAp();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            this.model.totalinv = this.model.ttlamtdue;
            this.ordLines=data[2]; //additional 28 May 2021      
            this.otherRcv=data[3]; //additional 28 May 2021  
            this.partialRcvConfirm=false;    
            this.model.partialRcv=0;
            if (this.ordLines.length !== lines.length) {
                this.model.partialRcv=1;
                this.partialRcvConfirm=true;
            } else {
                // if (this.otherRcv.length>0){
                //     console.log('this.otherRcv.length: ', this.otherRcv);
                //     this.model.partialRcv=1;
                // } else {
                    this.Lines.forEach(item => {
                        if (item.quantity<item.QtyPO) {
                            console.log('lines[i].quantity<lines[i].QtyPO: ', lines[i].quantity,lines[i].QtyPO);
                            this.model.partialRcv=1;
                            this.partialRcvConfirm=true;
                        }                                            
                    });
                // }
            }
        } catch (error) {
            this.isLoading=false;
            this.lkuPorderShow=true;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='header'){
            this.model.apkodeacc = _selected.kodeacc;
            this.model.apnamaacc = _selected.namaacc;
            this.model.postgroup = (_selected.kodeacc || '').substring(0,6);   
            const apgroup= this.postGroups.find(d => d.value==this.model.postgroup);    
            if (apgroup) {
                this.model.postgrpname = apgroup.text;
            } else {
                this.model.postgroup=''
            }            
        } else if (this.lkuCoaCaller==='debit'){
            this.apLinesObj.amortzaccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.apLinesObj.amortzkodeacc = _selected.kodeacc;
            this.apLinesObj.amortznamaacc = _selected.namaacc;
        } else {
            this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.apLinesObj.kodeacc = _selected.kodeacc;
            this.apLinesObj.namaacc = _selected.namaacc;
            this.dimension.forEach((dim) => {
                if (_selected[dim.value]) {
                    this.apLinesObj[dim.value] = _selected[dim.value];
                    this.apLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                    this.apLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                    // this.apLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                }
            });        
            const ketemu = this.prepaidexps.find(ac => ac.kodeacc==this.apLinesObj.kodeacc);
            this.prepaidexp= (ketemu);
            console.log ('prepaidexp : ',this.prepaidexp);
            if (this.prepaidexp){
                toastr.info('Prepaid Expense, should be Amortized');
            }
        }
        this.lkuCoaShow=false;
    },

    closeApLines: function(){
        const opened= this.apLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addApLines : function () {
        this.closeApLines();
        const obj={_showDetails:true};
        this.watching_pasalpph=false;            
        this.apLines.selected = obj;
        // this.apLinesObj.unitsize='EACH';
        this.apLinesObj.apdtlkey = '';
        this.apLinesObj.quantity = 1;
        // this.apLinesObj.kenappn = 0;
        this.apLinesObj.dppnlain = 100;
        this.apLinesObj.ppn = this.tarifPPN;
        this.apLinesObj.unitprice= 0;
        // this.apLinesObj.pasalpph='N/A',
        // this.apLinesObj.pph = 0;
        this.apLinesObj.kodeacc='';
        this.apLinesObj.uraian_dt='';
        this.apLinesObj.DimTableKey='';
        this.apLinesObj.nilai=0;
        this.apLinesObj.ibudghdkey='N/A';
        this.apLinesObj.ibudgdtkey='N/A';
        this.apLinesObj.ibudgdtkeyflag='YES';
        this.inputLineBerlanjut=1;
        this.updateDimHdr2Dtl(this.apLinesObj);
        this.apLines.items.push(obj);
        this.apLines.total=this.apLines.items.length;
        this.tabIndex=0;
        setTimeout(() => {
                const bfore = this.apLines.page;
                const after =Math.ceil((this.apLines.total)/this.apLines.limit);
                if (bfore != after){
                    this.apLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.apLines.total} items`,'Line/Detail',10000);
                }

        }, 100);    
        this.inputLineBerlanjut=1;
        setTimeout(() => {
            this.watching_pasalpph=true;            
        }, 300);
    },
    editApLines : function (obj,callback) {
        this.closeApLines();
        this.apLines.selected = obj;
        this.watching_pasalpph=false;            
        this.apLinesObj.apdtlkey = '';
        this.apLinesObj.kodeacc = '';
        this.apLinesObj.uraian_dt = '';
        this.apLinesObj.quantity = 0;
        this.apLinesObj.unitprice = 0;
        this.apLinesObj.nilai = 0;
        this.apLinesObj.nilaipph = 0;
        this.apLinesObj.ppn = 0;
        this.apLinesObj.kenappn = 0;
        this.apLinesObj.pasalpph =  'N/A';
        this.apLinesObj.pph = 0; 
        this.apLinesObj.unitzise = '';
        this.apLinesObj.DimTableKey = '';
        this.apLinesObj.ibudghdkey='N/A';
        this.apLinesObj.ibudgdtkey='N/A';
        this.apLinesObj.ibudgdtkeyflag='YES';
        this.inputLineBerlanjut=0;
        
        this.calcPPh=obj.calcPPh||1;
        for (var key in obj) {
            this.apLinesObj[key] = obj[key];
        }
        this.apLinesObj.ppn= this.apLinesObj.ppn || this.tarifPPN;
        this.apLinesObj.pph = this.apLinesObj.pph || 0;
        this.apLinesObj.dppnlain= this.apLinesObj.dppnlain || 100;
        this.apLinesObj.amortzdate = this.apLinesObj.amortzdate ? moment(this.apLinesObj.amortzdate).format('YYYY-MM-DD') : '';

        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.apLinesObj[dim.value] = obj[dim.value];
                this.apLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.apLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        const ketemu = this.prepaidexps.find(ac => ac.kodeacc==this.apLinesObj.kodeacc);
        this.prepaidexp= (ketemu);
        // console.log ('prepaidexp : ',this.prepaidexp);
        if (this.prepaidexp){
            toastr.info('Prepaid Expense, should be Amortized');
        }

        this.tabIndex=0;
        this.inputLineBerlanjut=0;
        setTimeout(() => {
            this.watching_pasalpph=true;            
        }, 300);
        callback();
    },
    delApLines: function (index) {
        const row=this.apLines.items[index];
        if ((row.apunbill || 0)==1){
            toastr.error('AP UNBILL can not be deleted the form Detail/Line.', "ERROR MESSAGE");
        } else {
            if (index > -1) {
                // this.apLines.items.splice(index, 1);
                const posisi = (this.apLines.page-1)*this.apLines.limit;
                this.apLines.items.splice(posisi+index, 1);
            }
            this.apLines.total=this.apLines.items.length;
            this.calcTotalDtlAp();
        }
    },
    saveApLines: async function (callback) {
        this.calcTaxes();
        if (this.invalidApLines) {
            const invalidobj = {};
            for (var key in this.$v.apLinesObj) {
            if (this.$v.apLinesObj[key].$anyError) {
                if (this.$v.apLinesObj[key].$anyError == true) invalidobj[key] = this.$v.apLinesObj[key];
            }
            }
            console.log('validation apLinesObj: ', this.apLinesObj);
            console.log('validation field: ', invalidobj);

            toastr.error('Please fill the form Detail/Line correctly.', "ERROR MESSAGE");
       } else {
           if (!(this.model.uraian)) {
               this.model.uraian=this.apLinesObj.uraian_dt;
           }
           if (this.tabIndex===0) {
                if (this.prepaidexp){
                    toastr.info('Prepaid Expense, should be Amortized');
                }
                for (var key in this.apLinesObj) {
                    this.apLines.selected[key] = this.apLinesObj[key];
                }
                this.calcTotalDtlAp();
                toastr.info('fill Dimmension for Invoice Item');
               this.tabIndex=1;
               return
           }
            let datadim=this.apLinesObj;
            datadim.TableName = 'ap_invoice_dt';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.apLinesObj) {
                        this.apLines.selected[key] = this.apLinesObj[key];
                    }
                    this.apLines.selected.calcPPh= this.calcPPh;
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.apLines.selected[dim.value] = datadim[dim.value];
                            this.apLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.apLines.total=this.apLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlAp();
                    this.apLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addApLines();
                        this.$v.apLinesObj.$reset();                        
                    }

                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else if (Math.abs(this.model.totalinv - parseFloat(this.model.ttlamtdue))>0.5) {
            toastr.error('[Total Invoice] not Balance with [Total Detail Invoice]', "ERROR MESSAGE",10000);
            this.isLoading=false;            
        } else {
            if ((this.saveClick===false) && (this.model.tagihandp==0)) {
                this.saveClick=true;
                this.isLoading=false;   
                this.showApDownpay();         
                return;
            }        
            if ((this.model.po) && (this.model.tagihandp==1) && (this.model.termin)) {
                toastr.info("Check Condition & Document untuk Invoice Termin/DP", "Procurement",6000);
                const hasilCek = await apinv.cekTerminKomplit({ po: this.model.po, termin: this.model.termin, apinvkey: this.model.apinvkey||'' });
                console.log("Hasil Check Condition & Document untuk Invoice Termin/DP: ", hasilCek);
                if (hasilCek.komplit==0) {
                    toastr.error(`${this.model.termin} Order#.${this.model.po} belum dikonfirmasi oleh bag. Purchasing`, "Save AP Error",10000);                
                    this.isLoading=false;   
                    return;
                } else if (hasilCek.invoiced==1) {
                    if ((hasilCek.nilaiTermin *2 ) <= (hasilCek.totInvoiced+this.model.totalinv)) {
                        toastr.error(`${this.model.termin} Order#.${this.model.po} sudah pernah ditagihkan`, "Save AP Error",10000);                
                        this.isLoading=false;   
                        return;
                    }
                } 
            }

            try {
                this.isLoading=true;
                
                if (this.model.ibudghdkey) {
                    let valid = await this.validasiBudget(this.apLines.items);
                    if (!valid) {
                        toastr.error('Realization exceeds BUDGET!', "ERROR MESSAGE");
                        this.saveEnabled = true;
                        this.isLoading = false;
                        return;
                    }

                    const hasBudgetLineRefer = this.apLines.items.some(item => (item.kodeacc || '') != '' && item.ibudgdtkeyflag !== 'YES' && item.ibudgdtkey && item.ibudgdtkey !== 'N/A');
                    if (!hasBudgetLineRefer) {
                        toastr.error('Harus ada lines/detail AP yang merefer ke budget line', "Error - Line/Detail AP", 10000);
                        this.saveEnabled = true;
                        this.isLoading = false;
                        return;
                    }
                }
                this.model.TableName = 'ap_invoice_tt';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PO;
                    this.model.apinvkey = this.model.apinvkey || '';
                    this.model.nomor = this.model.nomor || '';
                    this.model.taxliable= this.model.taxliable || 1;
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : undefined;
                    row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : undefined;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;
                    row.calcVAT=this.calcVAT || 1;
                    if (this.model.tagihandp==0) this.model.termin='';
                    
                    let budgetLineExist=false;
                    let itemValid=false;
                    let lineno=1;
                    let newApLines = this.apLines.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            if (this.model.ibudghdkey) {
                                if (item.ibudgdtkey) {
                                    if (item.ibudghdkey=='N/A')
                                        itemValid= true;
                                    else {
                                        if (this.model.ibudghdkey==item.ibudghdkey) {
                                            itemValid= true;
                                            budgetLineExist=true;
                                        } else {
                                            itemValid= false;
                                            throw new Error(`Expenses "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                                        }
                                    }
                                } else itemValid= false;
                            } else itemValid= true;

                            if (itemValid==true) {
                                item.lineno = lineno;
                                item.amortzdate = item.amortzdate ? moment(item.amortzdate).format('YYYY-MM-DD') : '';
                                newArr.push(item);
                                lineno += 1;
                            }
                        }
                        return newArr;
                    }, []);
                    if ((this.model.ibudghdkey) && (budgetLineExist==false)) {
                        toastr.error('There are no reference to [Internal Budget Line]', "Error - Line/Detail AP",10000);
                        this.isLoading=false;  
                        return;          
                    }
                    if (newApLines.length>0) {
                        row.lines = newApLines;
                        row.apDpSttl = this.apDpSttl.items;
                        // await apinv.insert(row);
                        // toastr.success("Complete successfully", "Save AP");
                        // this.close();
                        const hasil= await apinv.insert(row);
                        this.isLoading=false;
                        toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save AP",10000);
                        if (this.inputBerlanjut==0){
                            this.close();
                        } else {
                            this.isLoading=false;            
                            // const tanggal = this.model.tanggal;
                            this.model.ttlamtdue = 0;
                            this.model.ttlnetto = 0;
                            this.model.nilaippn = 0;
                            this.model.totalpph = 0;
                            this.model.totalap = 0;
                            const keys = ['tanggal','ttlamtdue','ttlnetto', 'nilaippn','grossup','totalap', 'totalpph' ];                
                            
                            for (var key in this.model) {
                                if (keys.indexOf(key) == -1) {
                                    this.model[key] = '';
                                }
                            }
                            this.model.ratekurs=1;
                            this.model.kursppn=1;

                            this.model.apinvkey = '';
                            this.apLines.items=[];
                            this.apDpSttl.items=[];
                            this.calcTotalDtlAp();
                            this.$v.model.$reset();
                            this.saveEnabled=true;                        
                        }
                    } else {
                        toastr.error(
                            "Please fill at least 1(one) line/Detail transaction",
                            "ERROR MESSAGE"
                        );
                        this.saveEnabled = true;
                    }                    
                } else {
                    this.isLoading=false;
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.isLoading=false;            
                }

            } catch (error) {
                    this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
            }

        }
    },
    saveinfo: async function () {
        this.isLoading=true;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else {
            try {
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.apinvkey = this.model.apinvkey;
                    row.invoice = this.model.invoice;
                    row.nofaktur = this.model.nofaktur;
                    row.invdate = this.model.invdate ? moment(this.model.invdate).format('YYYY-MM-DD') : undefined;
                    row.duedate = this.model.duedate ? moment(this.model.duedate).format('YYYY-MM-DD') : undefined;
                    row.tglfaktur = this.model.tglfaktur ? moment(this.model.tglfaktur).format('YYYY-MM-DD') : undefined;

                    if (this.model.ibudghdkey) {
                        const hasBudgetLineRefer = this.apLines.items.some(item => (item.kodeacc || '') != '' && item.ibudgdtkeyflag !== 'YES' && item.ibudgdtkey && item.ibudgdtkey !== 'N/A');
                        if (!hasBudgetLineRefer) {
                            toastr.error('Harus ada lines/detail AP yang merefer ke budget line', "Error - Line/Detail AP", 10000);
                            this.saveEnabled = true;
                            this.isLoading = false;
                            return;
                        }
                    }
                    let budgetLineExist=false;
                    let itemValid=false;
                    let lineno=1;
                    let newApLines = this.apLines.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            if (this.model.ibudghdkey) {
                                if (item.ibudgdtkey) {
                                    if (item.ibudghdkey=='N/A')
                                        itemValid= true;
                                    else {
                                        if (this.model.ibudghdkey==item.ibudghdkey) {
                                            itemValid= true;
                                            budgetLineExist=true;
                                        } else {
                                            itemValid= false;
                                            throw new Error(`Expenses "${item.uraian}" refer to Budget Line NOT FROM Internal Budget`);
                                        }
                                    }
                                } else itemValid= false;
                            } else itemValid= true;

                            if (itemValid==true) {
                                item.lineno = lineno;
                                item.amortzdate = item.amortzdate ? moment(item.amortzdate).format('YYYY-MM-DD') : '';
                                newArr.push(item);
                                lineno += 1;
                            }
                        }
                        return newArr;
                    }, []);
                    if ((this.model.ibudghdkey) && (budgetLineExist==false)) {
                        toastr.error('There are no reference to [Internal Budget Line]', "Error - Line/Detail AP",10000);
                        this.isLoading=false;  
                        return;          
                    }
                    row.lines = newApLines;
                    await apinv.saveinfo(row);
                    this.isLoading=false;
                    toastr.success(`Success update seconderay info of AP-Invoice Number ${this.model.nomor}`, "Save AP Invoice's Info",10000);
                    this.close();

            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.apLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlAp: function () {
        try {
            this.apLines.total=this.apLines.items.length;
            this.calcVAT = this.calcVAT || 1;
            let nilaippn = 0;
            let ttlnetto = 0;
            let nilaidpp = 0;
            // let ttlamtdue = 0;
            let totalpph = 0;
            // console.log('this.apLines.items : ',this.apLines.items);
            this.apLines.items.forEach((trx)=> {
                if (trx.kodeacc) {
                    ttlnetto += (trx.nilai || 0);
                    nilaippn += (trx.nilaippn || 0);
                    // ttlamtdue = ttlnetto + (nilaippn || 0);
                    if ((!(trx.nilaippn)) && (this.model.grossup == 1)) {
                        trx.dpp = trx.dpp * (100 / (100 - trx.pph));
                    } else {
                        trx.dpp=trx.nilai;
                    }
                    if (this.calcPPh == 1) {
                        trx.nilaipph = trx.dpp * parseFloat(trx.pph) / 100
                    }

                    totalpph += parseFloat(trx.nilaipph || 0);
                    nilaidpp += parseFloat(trx.dpp || 0);
                }
            });
            this.model.ttlnetto = ttlnetto;
            this.model.nilaidpp = nilaidpp;
            this.model.totalpph = totalpph;
            if (this.calcVAT == 1){
                this.model.nilaippn = nilaippn;
            }
            this.model.ttlamtdue = this.model.ttlnetto+this.model.nilaippn;
            if (this.model.grossup==1) {
                this.model.totalap = this.model.ttlamtdue;
            } else {
                this.model.totalap = this.model.ttlamtdue - this.model.totalpph;
            }
            
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            
        }
    },
    validasiBudget: async function(arrExc) {
        let arrRekap = [];

        for (let i = 0; i < arrExc.length; i++) {
            let d = arrExc[i];
            d._rowVariant = '';
            if (d.ibudgdtkey && d.ibudgdtkey !== 'N/A') {
                let ada = arrRekap.find(o => o.ibudgdtkey === d.ibudgdtkey);
                
                let budgetbalance = 0;
                try {
                    const res = await procure.budgetprogressdtlsmry({ ibudgdtkey: d.ibudgdtkey });
                    if (res) {
                        const isApEdit = this.model.apinvkey && d.apdtlkey;
                        if (isApEdit) {
                            budgetbalance = res.ibbudgetamt - (res.usagettl || 0) + (d.nilaiB4 || 0);
                        } else {
                            budgetbalance = res.ibbudgetamt - (res.usagettl || 0);
                        }
                    }
                } catch (err) {
                    console.error('Error fetching budget balance:', err);
                }

                if (!ada) {
                    arrRekap.push({
                        ibudgdtkey: d.ibudgdtkey,
                        claimTot: (d.nilai || 0),
                        budgetbalance: budgetbalance
                    });
                } else {
                    ada.claimTot = ada.claimTot + (d.nilai || 0);
                    const isApEdit = this.model.apinvkey && d.apdtlkey;
                    if (isApEdit) {
                        ada.budgetbalance = ada.budgetbalance + (d.nilai || 0);
                    }
                }
            }
        }

        const adaLebih = arrRekap.find(o => o.claimTot > o.budgetbalance);
        if (adaLebih) {
            const inValid = arrExc.find(o => o.ibudgdtkey === adaLebih.ibudgdtkey);
            inValid._rowVariant = 'danger';
            return false;
        } else {
            return true;
        }        
    },
    tanggalBerubah: function(){
            const newval=moment(this.model.tanggal).format('YYYY');
            if ( this.tahun != newval) {
                this.tahun=newval ;
                apinv.getcoa({ tahun: this.tahun}).then(result => {
                        this.coa = result;
                        if  (this.coa.length==0) {
                            this.getCoa();
                        }                        
                    })
                    .catch(err => {
                        console.log('get COA -> ', err);
                    });
            } else if  (this.coa.length==0) {
                this.getCoa();
            }
    },
    getCoa: function(){
        this.tahun=(this.$store.state.user.tglaktif || '').substring(0,4)                
        apinv.getcoa({ tahun: this.tahun}).then(result => {
                this.coa = result;
            })
            .catch(err => {
                console.log('get COA -> ', err);
            });
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'payable.apinvfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
